import { cache } from '@/container/apollo-client/cache';
import {
  WorkspaceMemberNotificationCounter,
  WorkspaceMembers,
  useMarkMemberChatAsReadMutation,
  useWorkspaceMemberNotificationCounterSubscription,
} from '@/types/generated/graphql';
import { gql } from '@apollo/client';
import { useMatch } from 'react-router-dom';

const FRAGMENT_WORKSPACE_MEMBER_UNREAD = gql`
  fragment WorkspaceMemberUnreadCounter on WorkspaceMembers {
    id
    unreadCounter
  }
`;

export const useWorkspaceMemberNotificationCounterHandler = () => {
  const matchConversation = useMatch({
    path: '/conversations/member/:memberId',
    end: false,
  });

  const activeMemberId = matchConversation?.params?.memberId ?? '';

  const [markAsRead] = useMarkMemberChatAsReadMutation();

  useWorkspaceMemberNotificationCounterSubscription({
    onData: (res) => {
      handleOnData({
        data: res?.data?.data?.workspaceMemberNotificationCounter as WorkspaceMemberNotificationCounter,
        activeMemberId,
        markAsRead,
      });
    },
  });
};

function handleOnData({
  data,
  activeMemberId,
  markAsRead,
}: {
  data: WorkspaceMemberNotificationCounter;
  activeMemberId: string;
  markAsRead: (options: { variables: { roomId: number } }) => void;
}) {
  if (!data) return;

  const isChatOpen = String(data.memberId) === activeMemberId;

  if (isChatOpen && data.roomId) {
    markAsRead({ variables: { roomId: data.roomId } });
  }

  cache.writeFragment<WorkspaceMembers | null>({
    fragment: FRAGMENT_WORKSPACE_MEMBER_UNREAD,
    id: 'WorkspaceMembers:' + data.memberId,
    data: {
      unreadCounter: isChatOpen ? 0 : data.counter,
    },
  });
}
